var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.833252,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 9.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 38.5,37.5 c 1.6545,0 3,-1.3455 3,-3 V 34 c 0,-1.6545 -1.3455,-3 -3,-3 -1.6545,0 -3,1.3455 -3,3 v 0.5 c 0,1.6545 1.3455,3 3,3 z",
    fill: "#82c100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 42.161,38.9905 c -2.352,-0.6515 -4.9695,-0.6515 -7.322,0 C 33.7565,39.2905 33,40.282 33,41.4025 V 43 h 11 v -1.5975 c 0,-1.1205 -0.7565,-2.112 -1.839,-2.412 z",
    fill: "#82c100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m 26.3253,14.124 c 0.0266,-0.2143 -0.0169,-0.4315 -0.124,-0.619 -0.1072,-0.1876 -0.2721,-0.3354 -0.4702,-0.4214 -0.1981,-0.086 -0.4187,-0.1055 -0.6289,-0.0557 -0.2101,0.0498 -0.3985,0.1663 -0.5369,0.3321 l -8.93,10.715 c -0.154,0.185 -0.31,0.373 -0.424,0.538 -0.108,0.155 -0.304,0.462 -0.31,0.864 -0.0035,0.2276 0.0448,0.4531 0.1413,0.6592 0.0965,0.2062 0.2386,0.3877 0.4157,0.5308 0.313,0.253 0.674,0.298 0.863,0.315 0.2,0.018 0.443,0.018 0.684,0.018 h 6.195 l -0.86,6.876 c -0.0269,0.2146 0.0164,0.4321 0.1236,0.6199 0.1071,0.1879 0.2722,0.3359 0.4706,0.422 0.1984,0.086 0.4193,0.1055 0.6297,0.0554 0.2104,-0.0501 0.3988,-0.1671 0.5371,-0.3333 l 8.93,-10.715 c 0.154,-0.185 0.31,-0.373 0.424,-0.538 0.108,-0.155 0.304,-0.462 0.31,-0.864 0.0035,-0.2276 -0.0448,-0.4531 -0.1413,-0.6592 -0.0965,-0.2062 -0.2386,-0.3877 -0.4157,-0.5308 -0.313,-0.253 -0.674,-0.298 -0.863,-0.315 C 32.1453,21 31.9033,21 31.6613,21 h -6.195 l 0.86,-6.876 z",
    fill: "#82c100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureQuestion);
export default __webpack_public_path__ + "static/media/feature_question.4b1433fc6f9fcbe92472ac7bdd7570bc.svg";
export { ForwardRef as ReactComponent };